import ExperimentsLoader from './ExperimentsLoader'

import { initEx } from './core'

initEx()

export default ExperimentsLoader
export { showEx, setEx } from './core'
export { useExperiment } from './hooks'
